// Route Code Edited 4/16/26
/**
 * Route Add-to-Cart Checkout Sync Handler
 * ========================================================
 * Some cart apps disable the original checkout button during cart updates,
 * blocking Route's redirect. We patch fetch early to detect Route's add.js,
 * then wait for the button to re-enable before clicking it.
 *
 * Load without defer/async before </body> in theme.liquid:
 * <script src="{{ 'route-checkout-sync-handler.js' | asset_url }}"></script>
 */
(function () {
  // Shared between Part 1 and Part 2 — skip body parsing until Route button is clicked
  let checkoutInitiated = false;

  // ─── PART 1: Patch fetch before any other scripts can wrap it ──────────────
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const promise = _fetch.apply(this, args);
    if (url.includes('cart/add.js')) {
      promise.then(async (res) => {
        if (!checkoutInitiated) return;
        let body = null;
        try { body = await res.clone().json(); } catch (e) {}
        window.dispatchEvent(new CustomEvent('route:fetch:end', { detail: { body } }));
      });
    }
    return promise;
  };

  // ─── PART 2: Monitor Route's button click and wait for the right moment ────
  document.addEventListener('DOMContentLoaded', function () {
    const ROUTE_BTN = '[data-route-cloned-button]';
    const ROUTE_HANDLE = 'routeins'; 
    const MAX_MS = 8000; 

    const s = document.querySelector('script[src*="shopify.widget.js"][src*="entrypoints"]');
    const ORIGINAL_BTN_BASE = (s ? new URL(s.src).searchParams.get('entrypoints[0].checkoutSelector') : null) ?? '[data-original-display]';
    const ORIGINAL_BTN = `${ORIGINAL_BTN_BASE}:not([data-route-widget] *):not([data-route-cloned-button])`;

    window.addEventListener('pageshow', (e) => { if (e.persisted) checkoutInitiated = false; });

    document.addEventListener('click', function (e) {
      if (!e.target.closest(ROUTE_BTN) || checkoutInitiated) return;
      checkoutInitiated = true;

      const container = (e.target.closest('[data-route-widget]') ?? e.target.closest('[data-route-widget-button]'))?.parentElement;
      const originalBtn = container?.querySelector(ORIGINAL_BTN) ?? document.querySelector(ORIGINAL_BTN);
      if (!originalBtn) { checkoutInitiated = false; return; }

      const maxTimer = setTimeout(() => {
        window.removeEventListener('route:fetch:end', onFetchEnd);
        enableObserver.disconnect();
        checkoutInitiated = false;
        originalBtn.click();
      }, MAX_MS);

      const enableObserver = new MutationObserver(() => {
        if (!originalBtn.disabled) {
          enableObserver.disconnect();
          clearTimeout(maxTimer);
          checkoutInitiated = false;
          originalBtn.click();
        }
      });

      function onFetchEnd(e) {
        if (!e.detail.body?.items?.some(i => i.handle === ROUTE_HANDLE)) return;
        window.removeEventListener('route:fetch:end', onFetchEnd);
        
        console.log('[Route sync] originalBtn.disabled at fetch end:', originalBtn.disabled);
        enableObserver.observe(originalBtn, { attributes: true, attributeFilter: ['disabled'] });
        if (!originalBtn.disabled) {
          enableObserver.disconnect();
          clearTimeout(maxTimer);
          checkoutInitiated = false;
          originalBtn.click();
        }
      }

      window.addEventListener('route:fetch:end', onFetchEnd);
    }, true);
  });
})();